/**
 * L'appui long qui prend un article de l'offre ou de la facture, au doigt.
 *
 * <p>« Quand je fais défiler pour lire les articles, je les déplace sans le
 * vouloir » : le doigt posé sur l'article le prenait dès qu'il bougeait. Au
 * doigt, l'article se prend maintenant en restant posé un instant dessus ; le
 * doigt qui glisse aussitôt fait défiler la page. À la souris, l'article se
 * prend toujours en le tirant.
 */

/** Durée de l'appui, en millisecondes, avant que l'article soit pris. */
export const DUREE_APPUI_LONG = 450;

/** Le doigt qui bouge de plus que cela pendant l'appui fait défiler la page. */
export const TOLERANCE_APPUI = 8;

/** Une courte vibration quand l'article est pris, si le téléphone le permet. */
export function vibre() {
  try {
    if (navigator.vibrate) navigator.vibrate(12);
  } catch {
    // Pas de vibration : l'article se soulève à l'écran.
  }
}

/**
 * Empêche la page de défiler sous le doigt tant qu'un article est pris : sans
 * cela, le téléphone prenait le glissé pour un défilement et lâchait l'article.
 *
 * @param {() => boolean} estPris vrai pendant qu'un article est déplacé
 * @returns {() => void} retire la protection
 */
export function bloqueLeDefilementPendant(estPris) {
  const bloque = (ev) => {
    if (estPris() && ev.cancelable) ev.preventDefault();
  };
  document.addEventListener('touchmove', bloque, { passive: false });
  return () => document.removeEventListener('touchmove', bloque);
}

/**
 * Le style d'une zone qui se prend à l'appui long : la page y défile du doigt,
 * sans sélection de texte ni menu du téléphone.
 */
export const ZONE_APPUI_LONG = {
  touchAction: 'pan-y',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  WebkitTouchCallout: 'none',
};
